export const LOGIN = 'auth:login';
export const SET_LOGIN_ERROR = 'auth:login-error';
export const LOGOUT = 'auth:logout';

export const CREATE_MEMBER = 'member:create';
export const FETCH_MEMBERS = 'member:getAll';
export const SET_MEMBERS = 'member:set-members';
export const FETCH_MEMBER = 'member:get';
export const SET_MEMBER = 'member:set-member';
export const DELETE_MEMBER = 'member:delete';
export const UPDATE_MEMBER = 'member:update';

export const CREATE_COURSE = 'course:create';
export const FETCH_COURSES = 'course:getAll';
export const FETCH_COURSE = 'course:get';
export const DELETE_COURSE = 'course:delete';
export const UPDATE_COURSE = 'course:update';
export const SET_COURSES = 'course:set-courses';
export const ADD_NEW_COURSE = 'course:addNewCourse';

export const SET_LOADED_USER = 'auth:set-loaded-user';

// REQUESTS
export const login = (data) => ({
  type: LOGIN,
  payload: data,
});

export const setLoginError = (data) => ({
  type: SET_LOGIN_ERROR,
  payload: data,
});

export const logout = () => ({
  type: LOGOUT,
});

export const createMember = (data) => ({
  type: CREATE_MEMBER,
  payload: data,
});

export const fetchMembers = () => ({
  type: FETCH_MEMBERS,
});

export const setMembers = (data) => ({
  type: SET_MEMBERS,
  payload: data,
});

export const fetchMember = (id) => ({
  type: FETCH_MEMBER,
  payload: id,
});

export const setMember = (data) => ({
  type: SET_MEMBER,
  payload: data,
});

export const updateMember = (data) => ({
  type: UPDATE_MEMBER,
  payload: data,
});

export const deleteMember = (id) => ({
  type: DELETE_MEMBER,
  payload: id,
});

// Courses
export const fetchCourses = () => ({
  type: FETCH_COURSES,
});

export const fetchCourse = (id) => ({
  type: FETCH_COURSE,
  payload: id,
});

export const updateCourse = (data) => ({
  type: UPDATE_COURSE,
  payload: data,
});

export const deleteCourse = (id) => ({
  type: DELETE_COURSE,
  payload: id,
});

export const setCourses = (data) => ({
  type: SET_COURSES,
  payload: data,
});

export const createCourse = (data) => ({
  type: CREATE_COURSE,
  payload: data,
});

export const addNewCourse = (course) => ({
  type: ADD_NEW_COURSE,
  payload: course,
});

// SETTERS
export const setLoadedUser = (data) => ({
  type: SET_LOADED_USER,
  payload: data,
});
